import { Box, Grid2 } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Loader from "../../../components/Loader";
import { Controller, useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import useNavigationGuard from "../../../hooks/useNavigationGuard";
import {
  checkCanUpdate,
  notifyError,
  notifySuccess,
} from "../../../utilities/helper";
import CustomSwitch from "../../../components/CustomSwitch/CustomSwitch";
import { MenuContext } from "../../../App";
import { CreateHandleUnsaveNavigation } from "../../../utilities/handleUnsaveNavigation";
import {
  createDispensationService,
  fetchDispensationByIdService,
  loadDispensationDataService,
  updateDispensationService,
} from "../../../services/dispensationManagementService";
import SearchableSelect from "../../../components/SearchableSelect";
import PageNotFoundWithoutNav from "../../../errorBoundaries/PageNotFound/PageNotFoundWithoutNav";

const AddUpdateDispensationManagement = () => {
  const id = useLocation()?.state?.id;

  const [load, setLoad] = useState(false);
  const [canUpdateDispensation, setCanUpdateDispensation] = useState(false);
  const [canAddDispensation, setCanAddDispensation] = useState(false);
  const [isReadOnly, setIsReadOnly] = useState(false);
  const [dispensationLoadingData, setDispensationLoadingData] = useState({
    treatmentData: [],
    visitData: [],
  });

  const navigate = useNavigate();

  const access_token = localStorage?.getItem("access_token");

  const { systemActions } = useContext(MenuContext);
  const handleUnsaveNavigation = CreateHandleUnsaveNavigation();

  const role = localStorage.getItem("role");

  const dispesationCreateSchema = yup.object().shape({
    visit: yup.string().required("Visit is required"),
    treatment: yup.string().required("Treatment is required"),
    isRequired: yup.boolean(),
  });

  const {
    register,
    handleSubmit,
    control,
    reset,
    formState: { errors, isDirty },
  } = useForm({
    resolver: yupResolver(dispesationCreateSchema),
    defaultValues: {
      visit: "",
      treatment: "",
      isRequired: false,
    },
  });

  useNavigationGuard(isDirty);

  useEffect(() => {
    if (access_token) {
      getLoadingData();
    }
  }, [access_token]);

  const { treatmentData, visitData } = dispensationLoadingData;

  useEffect(() => {
    if (systemActions?.length > 0 && role !== "Admin" && id) {
      let canUpdate = false;
      const updateFound = systemActions?.find(
        (item) => item?.name === "CanEditDispensation"
      );
      if (updateFound) {
        canUpdate = true;
      }
      setCanUpdateDispensation(canUpdate);
    } else {
      if (!id && role !== "Admin") {
        let canAdd = false;
        const createFound = systemActions?.find(
          (item) => item?.name === "CanCreateDispensation"
        );
        if (createFound) {
          canAdd = true;
        }
        setCanAddDispensation(canAdd);
      } else if (!id || role === "Admin") {
        setCanUpdateDispensation(true);
        setCanAddDispensation(true);
      }
    }
  }, [systemActions, id]);

  // useEffect(() => {
  //   if (role === "Admin") {
  //     setCanUpdateDispensation(true);
  //     return;
  //   }

  //   if (!id) {
  //     const canAdd = systemActions?.some(
  //       (item) => item?.name === "CanCreateDispensation"
  //     );
  //     setCanAddDispensation(!!canAdd);
  //   } else {
  //     const canUpdate = systemActions?.some(
  //       (item) => item?.name === "CanEditDispensation"
  //     );
  //     setCanUpdateDispensation(!!canUpdate);
  //   }
  // }, [systemActions, id, role]);

  useEffect(() => {
    if (id) {
      getDispensationById(id);
    }
  }, [id]);

  useEffect(() => {
    if (canUpdateDispensation || canAddDispensation) {
      setIsReadOnly(false);
    } else {
      setIsReadOnly(true);
    }
  }, [canUpdateDispensation, canAddDispensation]);

  const getLoadingData = async () => {
    try {
      setLoad(true);
      const res = await loadDispensationDataService(access_token);
      if (res?.data?.status == 200) {
        setLoad(false);
        setDispensationLoadingData({
          treatmentData: res?.data?.result?.treatmentData,
          visitData: res?.data?.result?.visits,
        });
      }
    } catch (err) {
      console.log(err.message);
      setLoad(false);
      if (err?.status == 401) {
        navigate("/unAuthorize");
      }
    }
  };

  const getDispensationById = async (id) => {
    setLoad(true);
    try {
      const res = await fetchDispensationByIdService(access_token, id);
      if (res?.status == 200) {
        const resp = res?.data?.result;
        setLoad(false);
        reset({
          visit: resp?.visitId,
          treatment: resp?.treatmentId,
          isRequired: resp?.isRequired,
        });
      }
    } catch (err) {
      setLoad(false);
      console.log(err.message);
      notifyError(err?.message);
      if (err?.status == 401) {
        navigate("/unAuthorize");
      }
    }
  };

  const addUpdateDispensation = async (data) => {
    setLoad(true);
    const newData = {
      visitId: data?.visit,
      treatmentId: data?.treatment,
      isRequired: data?.isRequired,
    };

    try {
      if (!id) {
        const res = await createDispensationService(access_token, newData);
        if (res?.data?.status == 409) {
          setLoad(false);
          notifyError("Dispensation already exists !");
          return;
        } else if (res?.status == 200) {
          setLoad(false);
          notifySuccess("Dispensation created successfully !");
          reset();
          navigate("/dispensation-management");
        }
      } else {
        const res = await updateDispensationService(access_token, newData, id);
        if (res?.status == 200) {
          setLoad(false);
          notifySuccess("Dispensation is Updated successfully !");
          reset();
          navigate("/dispensation-management");
        }
      }
    } catch (err) {
      setLoad(false);
      console.log(err.message);
      notifyError(err.message);
      if (err.status == 401) {
        navigate("/unAuthorize");
      }
    }
  };

  return (
    <>
      {!id && !canAddDispensation ? (
        <PageNotFoundWithoutNav />
      ) : (
        <>
          {load ? (
            <Loader />
          ) : (
            <div className="content-body">
              <p className="bread-crumbs-link-container">
                <button
                  className="bread-crumbs-btn"
                  onClick={(e) =>
                    handleUnsaveNavigation(e, isDirty, "", navigate)
                  }
                >
                  Home
                </button>{" "}
                |{" "}
                <button
                  className="bread-crumbs-btn"
                  onClick={(e) =>
                    handleUnsaveNavigation(
                      e,
                      isDirty,
                      "dispensation-management",
                      navigate
                    )
                  }
                >
                  Dispensation Management
                </button>{" "}
                |{" "}
                <button
                  className="bread-crumbs-btn"
                  to="/addUpdate-dispensation-management"
                >
                  {id ? "Edit Dispensation" : "Add Dispensation"}
                </button>
                -{" "}
                <b style={{ color: "gray" }}>
                  {localStorage?.getItem("studyName")}
                </b>
              </p>
              <Grid2
                container
                alignItems="center"
                justifyContent="space-between"
                sx={{ width: "100%", margin: "0 auto" }}
              >
                <Grid2 item md={12}>
                  <p className="page-heading">Dispensation Details</p>
                </Grid2>
              </Grid2>

              <Box
                component="form"
                autoComplete="off"
                sx={{ height: "auto", width: "100%" }}
                onSubmit={handleSubmit(addUpdateDispensation)}
              >
                <Grid2
                  container
                  alignItems="center"
                  justifyContent={"space-between"}
                  sx={{ width: "100%", margin: "0 auto" }}
                  gap={1}
                >
                  <Grid2 size={{ xl: 5, md: 5, lg: 5, sm: 12, xs: 12 }}>
                    <div>
                      <p className="labelStyles">
                        Visit
                        <span>*</span>
                      </p>
                      <SearchableSelect
                        control={control}
                        data={visitData}
                        name={"visit"}
                        optionKey="id"
                        optionLabel="name"
                        isReadOnly={isReadOnly}
                      />
                    </div>
                    {errors.visit && (
                      <div className="error-container">
                        {errors.visit.message}
                      </div>
                    )}
                  </Grid2>{" "}
                  <Grid2 size={{ xl: 5, md: 5, lg: 5, sm: 12, xs: 12 }}>
                    <div>
                      <p className="labelStyles">
                        Treatment
                        <span>*</span>
                      </p>
                      <SearchableSelect
                        control={control}
                        data={treatmentData}
                        name={"treatment"}
                        optionKey="id"
                        optionLabel="description"
                        isReadOnly={isReadOnly}
                      />
                    </div>
                    {errors.treatment && (
                      <div className="error-container">
                        {errors.treatment.message}
                      </div>
                    )}
                  </Grid2>
                  <Grid2 size={{ xl: 5, md: 5, lg: 5, sm: 12, xs: 12 }}>
                    <div>
                      <p className="labelStyles">Is Required</p>
                      <Controller
                        name="isRequired"
                        control={control}
                        disabled={isReadOnly}
                        defaultValue={false} // or your actual initial value
                        render={({ field }) => (
                          <CustomSwitch
                            isSwitch={field.value}
                            disabled={isReadOnly}
                            setSwitch={(val) => field.onChange(val)}
                          />
                        )}
                      />
                    </div>
                  </Grid2>
                </Grid2>

                <Grid2
                  alignItems={"end"}
                  justifyContent="end"
                  container
                  gap={3}
                  sx={{ marginTop: "2%" }}
                >
                  <Grid2 item md={6}>
                    <button
                      type="button"
                      className="create-btn-outlined"
                      onClick={(e) => {
                        e.preventDefault();
                        handleUnsaveNavigation(
                          e,
                          isDirty,
                          "dispensation-management",
                          navigate
                        );
                      }}
                    >
                      Cancel
                    </button>
                  </Grid2>
                  <Grid2 item md={6}>
                    {checkCanUpdate(id, isReadOnly, role) && (
                      <button
                        type="submit"
                        disabled={isReadOnly}
                        className={isReadOnly ? "disabled-btn" : "create-btn"}
                      >
                        {id ? "Update" : "Save"}
                      </button>
                    )}
                  </Grid2>
                </Grid2>
              </Box>
            </div>
          )}
        </>
      )}
    </>
  );
};

export default AddUpdateDispensationManagement;
